export default __webpack_public_path__ + "static/O0308-ce4381e5505d18533f3304d028046c13.png";